<template>
  <div>
    <div class="mt-5">
      <div class="columns">
        <div class="column">
          <p :class="['title mb-1', currentTheme === 'dark' ? 'has-text-white' : '']">Deposit</p>
          <p class="has-text-grey">Add assets or CMTY tokens to your wallet</p>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-3">
        <div :class="['box has-background-dark top-card', currentTheme === 'dark' ? 'has-text-black' : 'has-text-white']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-1">
              Total Supply: 10B CMTY
            </p>
            <p style="font-size: 0.95rem;">
              TVL: <span class="has-text-weight-bold">{{ formatTVL(totalValueLocked) }}</span> <span class="has-text-grey">CMTY</span>
            </p>
          </div>
        </div>
      </div>
      
      <div class="column is-3">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">User Balance</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Balance</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ userTokenBalance }}</span>
                <span class="ml-1">CMTY</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3" v-if="userNftId">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">NFT ID: #{{ userNftId }}</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Total Deposits</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ formatNFTBalance(userNftBalance) }}</span>
                <span class="ml-1">CMTYv</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="column is-3">
        <div :class="['balance-card', currentTheme === 'dark' ? 'is-dark' : '']">
          <div class="has-text-centered">
            <p class="has-text-weight-bold mb-3">Available for Withdraw</p>
            <div class="tags has-addons is-centered mt-2">
              <span class="tag is-dark">Max</span>
              <span class="tag is-info">
                <span class="has-text-weight-bold">{{ formatNFTBalance(maxWithdrawalAmount) }}</span>
                <span class="ml-1">CMTYv</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="box m-5">
      <div class="columns">
        <div class="column is-6">

          <div class="my-4">
            <p class="has-text-grey is-size-7">User wallet</p>
            <div class="field has-addons mb-1">
              <p class="control is-expanded">
                <input v-model="deposit.userWallet" :readonly="depositType=='cmty token' || isViewAsset" class="input" type="text" @blur="validateWallet" />
              </p>
            </div>
            <div v-if="walletValidationMessage" class="notification is-warning is-light mt-2">
              <button class="delete" @click="walletValidationMessage = null"></button>
              <p class="is-size-7">{{ walletValidationMessage }}</p>
              <p class="is-size-7 mt-2">
                <a href="https://cmtycoin.xyz/docs/" target="_blank" class="has-text-weight-bold">Read the manual here</a> to learn how to register your wallet in Cyclos.
              </p>
            </div>
          </div>

          <div class="my-4">
            <p class="has-text-grey is-size-7">Amount</p>
            <div class="field has-addons mb-1">
              <p class="control is-expanded">
                <input v-model="deposit.amount" :readonly="isViewAsset" class="input" type="number" />
              </p>
              <p class="control">
                <a class="button is-static"> CMTY </a>
              </p>
            </div>
          </div>

          <div v-if="isMinterUser && !isViewAsset">
            <div class="control">
              <label class="radio has-text-grey is-size-7">
                <input type="radio" value="cmty token" v-model="depositType" />
                CMTY Tokens
              </label>
              <label class="radio has-text-grey is-size-7">
                <input type="radio" value="other" v-model="depositType" />
                Other Assets
              </label>
            </div>
          </div>

          <div v-if="depositType=='other'" class="mt-5">
            <div class="control">
              <p class="mb-1 has-text-grey is-size-7">Asset Class</p>
              <div class="select is-fullwidth">
                <select v-model="selectedAssetClass">
                  <option v-for="assetClass in assetClasses" :key="assetClass" :value="assetClass"
                    :disabled="assetClass === 'CMTYv Deposit'">
                    {{ assetClass }}
                  </option>
                </select>
              </div>
              <p v-if="selectedAssetClass === 'CMTY Deposit'" class="help is-info">
                CMTY Deposit assets are system-managed and cannot be edited.
              </p>
            </div>

            <div class="control mt-2">
              <p class="mb-1 has-text-grey is-size-7">Name</p>
              <input class="input bg-color-main" v-model="nftName" type="text" />
            </div>

            <div class="control mt-2">
              <p class="mb-1 has-text-grey is-size-7">Description</p>
              <textarea class="textarea bg-color-main" v-model="nftDescription" rows="2"></textarea>
            </div>

            <p class="mt-5 has-text-grey is-size-7">Attributes</p>
            <p v-if="attributeList.length==0" class="has-text-centered is-size-7 has-text-grey mb-3">no attributes added</p>
            <div v-for="(x, index) in attributeList" :key="index" class="columns">
              <div class="column is-flex-grow-5">
                  <div class="control">
                      <p class="mb-1 has-text-grey is-size-7">Name</p>
                      <input class="input bg-color-main" v-model="x.trait_type" type="text" />
                  </div>
              </div>
              <div class="column is-flex-grow-5">
                  <div class="control">
                      <p class="mb-1 has-text-grey is-size-7">Value</p>
                      <input class="input bg-color-main" v-model="x.value" type="text" />
                  </div>
              </div>
              <div class="column mt-auto">
                  <button @click="removeAttribute(index)" class="button is-secondary"><i class="ri-delete-bin-line"></i></button>
              </div>
            </div>

            <div class="has-text-right">
              <button @click="addAttribute()" class="button is-main">Add Attribute</button>
            </div>
            
          </div>

        </div>

        <div class="column is-6 pt-5">
          <div v-if="depositType=='other'">
            <p class="mt-6 has-text-grey is-size-7">Image files (optional)</p>
            <p class="is-size-7 has-text-grey">You can upload multiple images. If no images are provided, a default image will be used</p>
            <div class="file is-boxed mt-2">
              <label class="file-label">
                <input class="file-input" type="file" multiple accept="image/*" @change="onChangeFileInput($event)" ref="fileInput">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="ri-upload-2-line"></i>
                  </span>
                  <span class="file-label">
                    Choose files...
                  </span>
                </span>
              </label>
            </div>
            
            <div v-if="imageFiles.length > 0" class="mt-4">
              <div v-for="(file, index) in imageFiles" :key="index" class="columns is-mobile is-vcentered mb-2">
                <div class="column">
                  <figure class="image is-64x64">
                    <img :src="imagePreviewUrls[index]" alt="Preview">
                  </figure>
                </div>
                <div class="column is-8">
                  <p class="is-size-7">{{ file.name }}</p>
                  <p class="is-size-7 has-text-grey">{{ Math.round(file.size / 1024) }} KB</p>
                </div>
                <div class="column">
                  <button @click="removeImage(index)" class="button is-small is-danger">
                    <span class="icon">
                      <i class="ri-delete-bin-line"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="depositType=='other'" class="has-text-centered mt-6">
            <img style="max-height: 450px;" :src="nftUrlImagePreview">
          </div>

          <!-- <div v-if="isViewAsset" class="has-text-centered mt-6">
            <img style="max-height: 450px;" :src="nftMetadata.image">

            <div class="mt-5">
              <a :href="'https://scan.v4.testnet.pulsechain.com/#/token/'+util.NFT_ContractAddress+'/instance/'+this.$route.params.token_id" target="_blank">View on Block Explorer</a>
            </div>
          </div> -->
        </div>


        <div class="column is-hidden-mobile">
        </div>
      </div>

      <div v-if="!isViewAsset" class="mt-6">
        <button v-if="depositType=='cmty token'" @click="approveToken()" class="button is-dark px-6" :disabled="!isWalletValid"> Deposit </button>
        <button v-if="depositType=='other'" @click="mint()" class="button is-dark px-6" :disabled="!isWalletValid"> Deposit </button>
      </div>
      <!-- <div v-if="isViewAsset && isUriSetterUser" class="mt-6">
        <button @click="update()" class="button is-dark px-6"> Update </button>
      </div> -->
    </div>

    <div v-if="!isViewAsset" class="box m-5">
      <div class="columns">
        <div class="column">
          <p class="mb-6 has-text-weight-bold">Deposit history</p>
          <!--
          <vue-countdown class="has-text-danger" v-if="counting" :time="60000" @end="onCountdownEnd" v-slot="{ totalSeconds }">The page will refresh automatically in <strong>{{ totalSeconds }}</strong> seconds</vue-countdown>
          -->
          
          <table class="table is-striped table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in depositList">
                <td>
                  <div class="tags has-addons">
                    <span class="tag is-dark">CMTY</span>
                    <span class="tag is-info">{{ x.amount }}</span>
                  </div>
                </td>
                <td>
                  <span class="tag is-info">{{ x.finished }}</span>
                </td>
              </tr>

              <tr v-if="depositList.length == 0">
                <td colspan="2">There are no transactions yet</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from "@/utilities/util.js";
import * as fileService from '@/services/file_service'

import Web3 from "web3";

export default {
  name: "DepositPage",
  data() {
    return {
      currentTheme: localStorage.getItem('theme') || 'light',
      imageFiles: [],
      imagePreviewUrls: [],
      isConnected: false,
      tokenContract: null,
      vaultContract: null,
      orchestratorContract: null,
      oracleContract: null,
      nftContractInstance: null,
      account: null,
      web3: new Web3(window.ethereum),
      nftImage: require('@/assets/nft.png'),
      vaultImage: require('@/assets/vault.png'),
      walletImage: require('@/assets/wallet.png'),
      userTokenBalance: 0,
      userNftId: null,
      userNftBalance: 0,
      maxWithdrawalAmount: 0,
      totalValueLocked: 0,

      deposit: {
        userWallet: null,
        amount: null,
      },
      depositList: [],
      counting: false,
      depositType: 'cmty token',
      nftName: null,
      nftDescription: null,
      attributeList: [],
      isMinterUser: false,
      isUriSetterUser: false,
      assetClasses: [],
      selectedAssetClass: '',
      isViewAsset: false,
      nftMetadata: {},
      util,
      nftUrlImagePreview: null,
      defaultNftImageUri: '', // Store the default image URI once uploaded
      walletValidationMessage: null,
      isWalletValid: true,
    };
  },
  created() {
    window.addEventListener('storage', this.handleThemeChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleThemeChange);
  },
  async mounted() {
    this.$watch(
      () => this.$store.state.isConnected,
      async (val) => {
        this.isConnected = val;
        if (val) {
          await this.loadHeaderData();
        }
      }
    );

    await util.reconnect();
    this.$store.commit("changeConnectionStatus", true);
    this.account = await util.getCoinbase();
    this.$store.commit("changeAccount", this.account);
    this.deposit.userWallet = this.account;

    this.$watch(
      () => {
        return this.depositType;
      },
      (val) => {
        if(val == 'cmty token'){
          this.deposit.userWallet = this.account;
          this.validateWallet();
        }
      }
    );
    
    // Watch for changes in userWallet to validate
    this.$watch(
      () => this.deposit.userWallet,
      (newWallet) => {
        if (newWallet && newWallet.length === 42) {
          this.validateWallet();
        }
      }
    );

    // Initialize contracts
    this.tokenContract = await util.tokenContractInstance();
    this.orchestratorContract = await util.OrchestratorContractInstance();
    this.oracleContract = await util.OracleContractInstance();
    this.nftContractInstance = await util.NFTContractInstance();
    
    // Get available asset classes
    await this.getAssetClasses();
    
    // Load header data
    await this.loadHeaderData();
    
    // Validate the initial wallet (which was set to this.account)
    if (this.deposit.userWallet && this.deposit.userWallet.length === 42) {
      await this.validateWallet();
    }

    if(this.$route.params.token_id){
      const token_id = this.$route.params.token_id
      this.isViewAsset = true
      this.depositType = 'other'

      this.deposit.amount  = util.subtractDecimals(await this.nftContractInstance.methods.balanceOf(this.account, token_id).call(), 18)
      const tokenUri = await this.nftContractInstance.methods.uri(token_id).call()
      this.nftMetadata = await (await fetch(tokenUri)).json()
      
      this.nftName = this.nftMetadata.name
      this.nftDescription = this.nftMetadata.description
      this.attributeList = this.nftMetadata.attributes
    }


    this.getDeposits();
    this.startCountdown();

    const MINTER_ROLE = await this.orchestratorContract.methods.MINTER_ROLE().call()
    const URI_SETTER_ROLE = await this.orchestratorContract.methods.MINTER_ROLE().call()
    this.isMinterUser = await this.orchestratorContract.methods.hasRole(MINTER_ROLE, this.account).call()
    this.isUriSetterUser = await this.orchestratorContract.methods.hasRole(URI_SETTER_ROLE, this.account).call()
  },
  methods: {
    formatNFTBalance(balance) {
      if (!balance) return '0';
      try {
        const decimalValue = util.subtractDecimals(balance, 18);
        const roundedValue = Math.round(parseFloat(decimalValue));
        return new Intl.NumberFormat('en-US').format(roundedValue);
      } catch (error) {
        console.error('Error formatting balance:', error);
        return '0';
      }
    },
    numberFormat(number) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(number);
    },
    async loadHeaderData() {
      try {
        if (!this.tokenContract) {
          return;
        }
        
        this.userTokenBalance = this.numberFormat(util.subtractDecimals(
          await this.tokenContract.methods.balanceOf(this.account).call(), 18
        ));
        
        this.userNftId = await this.nftContractInstance.methods.getUserToken(this.account).call();
        
        if (this.userNftId && this.userNftId !== '0') {
          const balance = await this.nftContractInstance.methods.balanceOf(this.account, this.userNftId).call();
          this.userNftBalance = balance;
        }
        
        // Get max withdrawal amount
        const maxWithdrawal = await this.orchestratorContract.methods.getMaxWithdrawalAmount(this.account).call();
        this.maxWithdrawalAmount = maxWithdrawal;
        
        // Get total value locked from Orchestrator
        const tvl = await this.orchestratorContract.methods.totalAssets().call();
        this.totalValueLocked = tvl;
      } catch (error) {
        console.error('Error loading header data:', error);
      }
    },
    formatTVL(tvl) {
      if (!tvl) return '0';
      try {
        const decimalValue = util.subtractDecimals(tvl, 18);
        const roundedValue = Math.round(parseFloat(decimalValue));
        return new Intl.NumberFormat('en-US').format(roundedValue);
      } catch (error) {
        console.error('Error formatting TVL:', error);
        return '0';
      }
    },
    async handleFileUpload(nftFile, loader) {
      let fileUri = '';
      
      // Optional file upload with validation and fallback mechanisms
      if (!nftFile || !nftFile.files || !nftFile.files[0]) {
        console.log("No file selected, will use default/placeholder image");
        return fileUri;
      }
      
      // File extension validation
      const allowedExtensions = ['.gif', '.jpg', '.png', '.jpeg', '.mp4', '.mp3'];
      const extension = nftFile.files[0].name.substring(nftFile.files[0].name.lastIndexOf(".")).toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        loader.hide();
        util.toast.fire({ icon: "error", title: `Please check the extension of the file you want to upload. Only files with the following extensions can be uploaded: ${allowedExtensions.join(", ")}` });
        throw new Error("Invalid file extension");
      }
      
      // Prepare and upload file
      try {
        var formData = new FormData();
        formData.append("file", nftFile.files[0]);
        const file_upload_response = await fileService.uploadFileToIPFS(formData);
        fileUri = 'https://ipfs.io/ipfs/' + file_upload_response.data.IpfsHash;
        console.log("File uploaded successfully:", fileUri);
        return fileUri;
      } catch (error) {
        console.error("Error uploading file:", error);
        loader.hide();
        util.toast.fire({ icon: "error", title: "Error uploading file. Please try again." });
        throw error;
      }
    },
    
    async getAssetClasses() {
      try {
        // Call the getAssetClasses function from the CMTYNFT contract
        const classes = await this.nftContractInstance.methods.getAssetClasses().call();
        this.assetClasses = classes;
        
        // Set default selected asset class if available
        if (classes.length > 0) {
          // Default to RWA if available, otherwise use the first non-CMTY Deposit class
          const rwaIndex = classes.findIndex(c => c === 'RWA');
          if (rwaIndex >= 0) {
            this.selectedAssetClass = 'RWA';
          } else {
            const nonDepositIndex = classes.findIndex(c => c !== 'CMTY Deposit');
            if (nonDepositIndex >= 0) {
              this.selectedAssetClass = classes[nonDepositIndex];
            } else {
              this.selectedAssetClass = classes[0];
            }
          }
        }
      } catch (error) {
        console.error('Error getting asset classes:', error);
        util.toast.fire({ icon: "error", title: "Error loading asset classes" });
      }
    },
    async update(){
      let loader = this.$loading.show({});
      try {

        if(this.nftName == null || this.nftName == ''){
          loader.hide()
          util.toast.fire({ icon: "error", title: "Name invalid" });
          return
        }
        if(this.nftDescription == null || this.nftDescription == ''){
          loader.hide()
          util.toast.fire({ icon: "error", title: "Description invalid" });
          return
        }

        const amount = BigInt(util.addDecimals(this.deposit.amount, 18));

        var formData = new FormData();
        var nftFile = document.querySelector('#nftFile');
        formData.append("file", nftFile.files[0]);

        // check selected and extension file
        if(!nftFile.files[0] || nftFile.files[0] == 'null' || nftFile.files[0] == undefined){
          loader.hide()
          util.toast.fire({ icon: "error", title: "No selected file" });
          return
        }
        const allowedExtensions = ['.gif', '.jpg', '.png'];
        const extension = nftFile.files[0].name.substring(nftFile.files[0].name.lastIndexOf(".")).toLowerCase();
        if (!allowedExtensions.includes(extension)) {
          loader.hide()
          util.toast.fire({ icon: "error", title: `Please check the extension of the file you want to upload. Only files with the following extensions can be uploaded: ${allowedExtensions.join(", ")}` });
          return
        }

        const file_upload_response = await fileService.uploadFileToIPFS(formData)

        const fileUri = 'https://ipfs.io/ipfs/'+file_upload_response.data.IpfsHash

        const metadata = {
          pinataContent: {
            name: this.nftName,
            description: this.nftDescription,
            image: fileUri,
            attributes: this.attributeList
          }
        }

        const metadata_upload_response = await fileService.uploadJsonToIPFS(metadata)
        const metadataUri = 'https://ipfs.io/ipfs/'+metadata_upload_response.data.IpfsHash
        console.log(metadataUri)

        await this.nftContractInstance.methods.setTokenURI(this.$route.params.token_id, metadataUri).send({ from: this.account })
        .on("receipt", async (receipt) => {
          loader.hide()
          util.toast.fire({ icon: "success", title: "Update completed!" });
        })
        .on("error", (error) => {
          console.log(error);
          loader.hide()
          util.toast.fire({ icon: "error", title: "please repeat process" });
        });
          
      } catch (error) {
        console.log(error);
        loader.hide()
        util.toast.fire({ icon: "error", title: "please repeat process" });
      }
    },
    addAttribute(){
      this.attributeList.push({})
    },
    removeAttribute(index){
      this.attributeList.splice(index, 1);
    },
    onChangeFileInput(event){
      const files = Array.from(event.target.files);
      files.forEach(file => {
        this.imageFiles.push(file);
        this.imagePreviewUrls.push(URL.createObjectURL(file));
      });
    },
    removeImage(index) {
      URL.revokeObjectURL(this.imagePreviewUrls[index]);
      this.imageFiles.splice(index, 1);
      this.imagePreviewUrls.splice(index, 1);
    },

    async mint() {
      let loader = this.$loading.show({});
      try{
        if(!this.deposit.userWallet){
          util.toast.fire({icon: 'error', title: 'please enter user wallet'});
          loader.hide();
          return;
        }
        // Validate wallet for other assets
        if (!this.isWalletValid) {
          await this.validateWallet();
          if (!this.isWalletValid) {
            util.toast.fire({icon: 'error', title: 'Please use a wallet registered in Cyclos'});
            loader.hide();
            return;
          }
        }
        if(!this.deposit.amount){
          util.toast.fire({icon: 'error', title: 'please enter amount'});
          loader.hide();
          return;
        }
        if(!this.selectedAssetClass){
          util.toast.fire({icon: 'error', title: 'please select asset class'});
          loader.hide();
          return;
        }
        if(!this.nftName){
          util.toast.fire({icon: 'error', title: 'please enter name'});
          loader.hide();
          return;
        }
        if(!this.nftDescription){
          util.toast.fire({icon: 'error', title: 'please enter description'});
          loader.hide();
          return;
        }

        // Upload images to IPFS if any
        let fileUris = [];
        if (this.imageFiles.length > 0) {
          for (const file of this.imageFiles) {
            const formData = new FormData();
            formData.append("file", file);
            const response = await fileService.uploadFileToIPFS(formData);
            fileUris.push('https://ipfs.io/ipfs/' + response.data.IpfsHash);
          }
        }

        // Continue with minting using the file URIs
        await this.continueWithMinting(loader, fileUris);
      }catch(error){
        console.log('Error in mint:', error);
        loader.hide();
        util.toast.fire({icon: 'error', title: 'Please repeat process'});
      }
    },

    async continueWithMinting(loader, fileUris = []) {
      try {
        const amount = BigInt(util.addDecimals(this.deposit.amount, 18));
        const attributeKeys = this.attributeList ? this.attributeList.map(x => x.trait_type) : [];
        const attributeValues = this.attributeList ? this.attributeList.map(x => x.value) : [];

        console.log('Checking preconditions...');
        console.log('Attribute Keys:', attributeKeys);
        console.log('Attribute Values:', attributeValues);
        
        // 1. Check if user has MINTER_ROLE
        const MINTER_ROLE = await this.orchestratorContract.methods.MINTER_ROLE().call();
        const hasMinterRole = await this.orchestratorContract.methods.hasRole(MINTER_ROLE, this.account).call();
        console.log('MINTER_ROLE:', MINTER_ROLE);
        console.log('User has MINTER_ROLE:', hasMinterRole);
        
        if (!hasMinterRole) {
          console.error('User does not have MINTER_ROLE. Transaction will likely fail.');
          loader.hide();
          util.toast.fire({ icon: "error", title: "Missing MINTER_ROLE permissions" });
          return;
        }
        
        // 2. Check if Orchestrator has ADMIN_ROLE in CMTYNFT
        const ADMIN_ROLE = '0xa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c21775';
        const orchestratorAddress = this.orchestratorContract._address;
        const hasAdminRole = await this.nftContractInstance.methods.hasRole(ADMIN_ROLE, orchestratorAddress).call();
        console.log('ADMIN_ROLE:', ADMIN_ROLE);
        console.log('Orchestrator has ADMIN_ROLE in CMTYNFT:', hasAdminRole);
        
        if (!hasAdminRole) {
          console.error('Orchestrator does not have ADMIN_ROLE in CMTYNFT. Transaction will fail.');
          loader.hide();
          util.toast.fire({ icon: "error", title: "Contract configuration error" });
          return;
        }
        
        // 3. Check Treasury allowance
        const treasuryAddress = await this.orchestratorContract.methods.treasury().call();
        const allowance = await this.tokenContract.methods.allowance(treasuryAddress, orchestratorAddress).call();
        console.log('Treasury allowance for Orchestrator:', util.subtractDecimals(String(allowance), 18), 'CMTY');
        
        if (BigInt(allowance) < amount) {
          console.error('Treasury has not approved Orchestrator to spend enough tokens. Transaction will fail.');
          loader.hide();
          util.toast.fire({ icon: "error", title: "Insufficient treasury allowance" });
          return;
        }
        
        // 4. Check attribute arrays length
        if (attributeKeys.length !== attributeValues.length) {
          console.error('Attribute arrays have different lengths. Transaction will fail.');
          loader.hide();
          util.toast.fire({ icon: "error", title: "Attribute arrays have different lengths" });
          return;
        }
        
        console.log('Amount:', amount.toString());
        console.log('Asset Class:', this.selectedAssetClass);
        console.log('Name:', this.nftName);
        console.log('Description:', this.nftDescription);
        console.log('File URIs:', fileUris);
        console.log('From account:', this.account);



        // Validate all parameters before calling contract
        if (!this.deposit.userWallet) {
          console.error('userWallet is undefined');
          loader.hide();
          util.toast.fire({ icon: "error", title: "User wallet is required" });
          return;
        }
        if (!this.selectedAssetClass) {
          console.error('selectedAssetClass is undefined');
          loader.hide();
          util.toast.fire({ icon: "error", title: "Asset class is required" });
          return;
        }
        if (!this.nftName) {
          console.error('nftName is undefined');
          loader.hide();
          util.toast.fire({ icon: "error", title: "NFT name is required" });
          return;
        }
        if (!this.nftDescription) {
          console.error('nftDescription is undefined');
          loader.hide();
          util.toast.fire({ icon: "error", title: "NFT description is required" });
          return;
        }
        if (!this.account) {
          console.error('account is undefined');
          loader.hide();
          util.toast.fire({ icon: "error", title: "Account is required" });
          return;
        }
        
        console.log('All parameters validated, calling contract...');
        


        
        // Call the tokenizeRWA function with the new parameters
        await this.orchestratorContract.methods.tokenizeRWA(
          this.deposit.userWallet, 
          amount,
          this.selectedAssetClass,
          this.nftName,
          this.nftDescription,
          fileUris.length > 0 ? fileUris : [""], // Pass array of URIs or empty array with default
          attributeKeys,
          attributeValues
        ).send({ from: this.account })
        .on("receipt", async (receipt) => {
          this.getDeposits();
          loader.hide();
          util.toast.fire({ icon: "success", title: "Deposit completed!" }).then(() => {
            window.location.reload();
          });
        })
        .on("error", (error) => {
          console.log(error);
          loader.hide();
          util.toast.fire({ icon: "error", title: "Please repeat process" });
        });
      } catch (error) {
        console.log('Error in continueWithMinting:', error);
        loader.hide();
        util.toast.fire({ icon: "error", title: "Please repeat process" });
      }
    },

    handleThemeChange(event) {
      if (event.key === 'theme') {
        this.currentTheme = event.newValue;
      }
    },
    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
      this.getDeposits();
      setTimeout(() => {
        this.startCountdown();
      }, 100);
    },
    async getDeposits() {
      this.depositList = [];

      const txCount = await this.oracleContract.methods
        .txsCount(this.account)
        .call();

      for (let i = 0; i < txCount; i++) {
        const tx = await this.oracleContract.methods
          .txsPerUser(this.account, i)
          .call();
        if (tx.toCyclos) {
          this.depositList.push({
            amount: util.subtractDecimals(tx.amount, 18),
            finished: tx.finished ? "Processed" : "Pending",
          });
        }
      }
    },

    async validateWallet() {
      if (!this.deposit.userWallet || this.deposit.userWallet.length !== 42) {
        return;
      }

      try {
        const apiUrl = `https://cmtycoin.xyz/api/?action=check-wallet&wallet=${this.deposit.userWallet}`;
        const response = await fetch(apiUrl);
        const data = await response.json();
        
        if (data.exists) {
          this.isWalletValid = true;
          this.walletValidationMessage = null;
        } else {
          this.isWalletValid = false;
          this.walletValidationMessage = '⚠️ This wallet is not registered in Cyclos. Deposits from unregistered wallets will not be processed.';
        }
      } catch (error) {
        console.error('Error validating wallet:', error);
        this.isWalletValid = false;
      }
    },
    async approveToken() {

      // Validate wallet first
      if (!this.isWalletValid && this.deposit.userWallet !== this.account) {
        util.toast.fire({ icon: "error", title: "Please use a wallet registered in Cyclos" });
        return;
      }

      const balance = util.subtractDecimals(
        await this.tokenContract.methods.balanceOf(this.account).call(),
        18
      );

      if (!this.deposit.amount || this.deposit.amount == 0) {
        util.toast.fire({ icon: "error", title: "please enter valid amount" });
        return;
      }
      if (this.deposit.amount > balance) {
        util.toast.fire({
          icon: "error",
          title: "amount exceeds your balance",
        });
        return;
      }

      let loader = this.$loading.show({});
      const amount = BigInt(util.addDecimals(this.deposit.amount, 18));

      const allowedTokens = BigInt(
        await this.tokenContract.methods
          .allowance(this.account, util.ORCHESTRATOR_ContractAddress)
          .call()
      );
      if (allowedTokens >= amount) {
        loader.hide();
        this.executeDeposit(amount);
        return;
      }

      const estimatedGas = await this.tokenContract.methods
        .approve(util.ORCHESTRATOR_ContractAddress, amount)
        .estimateGas({ from: this.account });
      const gasLimitWithBuffer = estimatedGas * util.GAS_MULTIPLIER;

      // Obtener gas price actual de la red
      const gasPrice = await this.web3.eth.getGasPrice();
      const gasPriceWithBuffer = BigInt(gasPrice) * BigInt(util.PRICE_MULTIPLIER); // 4x para inclusión rápida
      
      console.log(`GAS_MULTIPLIER: ${util.GAS_MULTIPLIER.toString()}`);
      console.log(`PRICE_MULTIPLIER: ${util.PRICE_MULTIPLIER.toString()}`);
      console.log(`Estimated gas: ${estimatedGas.toString()}`);
      console.log(`Gas limit (with buffer): ${gasLimitWithBuffer.toString()}`);
      console.log(`Gas price: ${this.web3.utils.fromWei(gasPrice.toString(), 'gwei')} gwei`);

      this.tokenContract.methods
        .approve(util.ORCHESTRATOR_ContractAddress, amount)
        .send({ from: this.account, gas: gasLimitWithBuffer, gasPrice: gasPriceWithBuffer.toString() })
        .on("receipt", async (receipt) => {
          util.toast.fire({ icon: "success", title: "tokens approved" });
          this.executeDeposit(amount);
          loader.hide();
        })
        .on("error", (error) => {
          loader.hide();
          console.log(error);
          util.toast.fire({ icon: "error", title: "transaction error" });
        });
    },
    executeDeposit(amount) {
      let loader = this.$loading.show({});
      
      // Estimar gas para deposit
      this.orchestratorContract.methods
        .deposit(amount)
        .estimateGas({ from: this.account })
        .then(async (estimatedGas) => {
          const gasLimitWithBuffer = estimatedGas * util.GAS_MULTIPLIER;

          // Obtener gas price actual de la red
          const gasPrice = await this.web3.eth.getGasPrice();
          const gasPriceWithBuffer = BigInt(gasPrice) * BigInt(util.PRICE_MULTIPLIER); // 4x para inclusión rápida
          
          console.log(`GAS_MULTIPLIER: ${util.GAS_MULTIPLIER.toString()}`);
          console.log(`PRICE_MULTIPLIER: ${util.PRICE_MULTIPLIER.toString()}`);
          console.log(`Estimated gas: ${estimatedGas.toString()}`);
          console.log(`Gas limit (with buffer): ${gasLimitWithBuffer.toString()}`);
          console.log(`Gas price: ${this.web3.utils.fromWei(gasPrice.toString(), 'gwei')} gwei`);

          this.orchestratorContract.methods
            .deposit(amount)
            .send({ from: this.account, gas: gasLimitWithBuffer, gasPrice: gasPriceWithBuffer.toString() })
            .on("receipt", async (receipt) => {
              this.getDeposits();
              loader.hide();
              util.toast.fire({ icon: "success", title: "deposit completed" }).then(() => {
                window.location.reload();
              });
            })
            .on("error", (error) => {
              loader.hide();
              console.log(error);
              util.toast.fire({ icon: "error", title: "transaction error" });
            });
        })
        .catch((error) => {
          loader.hide();
          console.log(error);
          util.toast.fire({ icon: "error", title: "gas estimation error" });
        });
    },
  },
};
</script>

<style scoped>
.nft-id-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nft-id-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.nft-id-card.is-dark p {
  color: #fff;
}

.nft-id-card img {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.balance-card {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1),
              0 8px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balance-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12),
              0 12px 24px rgba(0, 0, 0, 0.12);
}

.balance-card.is-dark {
  background: #2a2a2a;
  border-color: #363636;
  color: #fff;
}

.balance-card.is-dark p {
  color: #fff;
}

.balance-card img {
  border-radius: 4px;
}

.top-card {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
}
</style>
